import Auditing from "assets/images/offers/auditing.svg";
import Survey from "assets/images/offers/survey.svg";
import Retail from "assets/images/offers/retail.svg";
import Business from "assets/images/offers/business-development.svg";
import Background from "assets/images/offers/background-verification.svg";
import Catalog from "assets/images/offers/catalog.svg";
import Virtual from "assets/images/offers/virtual-call.svg";
import Experts from "assets/images/offers/experts.svg";

const offerContent = [
  {
    title: "Auditing",
    text: "Monitor and track all retail execution, store compliance, signage presence, and competitor activity in real-time.",
    image: Auditing,
  },
  {
    title: "Survey",
    text: "Gather reliable consumer feedback, demographic surveys, and pricing data directly from target audiences in the field.",
    image: Survey,
  },
  {
    title: "Retail Activation",
    text: "Drive product visibility, execute in-store promotions, conduct product demonstrations, and manage merchandising audits.",
    image: Retail,
  },
  {
    title: "Business Development",
    text: "Acquire new merchants, onboard retail partners, and drive B2B user sign-ups and app downloads on the ground.",
    image: Business,
  },
  {
    title: "Background Verification",
    text: "Ensure business trust and compliance with physical address checks, document verification, and agent onboarding validation.",
    image: Background,
  },
  {
    title: "Catalog & Content Operations",
    text: "Scale your digital catalog with product photography, precise item description writing, and metadata tagging.",
    image: Catalog,
  },
  {
    title: "Virtual Call Centres",
    text: "Deploy customer support and telesales agents speaking in local vernacular languages for onboarding and support.",
    image: Virtual,
  },
  {
    title: "Pehal Experts",
    text: "Consult with specialized industry experts to architect custom field operations and scale-up execution strategies.",
    image: Experts,
  },
];

const Offers = () => {
  return (
    <section className="section offers" id="offer">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-header text-center aos mb-5" data-aos="fade-up">
              <span className="section-subtitle">What We Deliver</span>
              <h2 className="offer-header-title">Our Offerings</h2>
              <p className="offer-desc">
                Custom gig workforce solutions tailored to execute operational workflows with high quality, speed, and real-time outcomes.
              </p>
            </div>
          </div>
        </div>
        <div className="g-4 flex-wrap justify-content-center row mt-2">
          {offerContent?.map((offer, i) => {
            return (
              <div className="col-12 col-md-6 col-xl-3" key={i}>
                <div className="offer-cards">
                  <div className="row flex-column align-items-center text-center px-2 py-3 m-0">
                    <div className="front_details">
                      <div className="offer-image">
                        <img
                          src={offer?.image}
                          className="img-fluid"
                          alt={offer?.title}
                        />
                      </div>
                      <div className="text-center">
                        <div className="card-body pt-2 pb-0 mb-0 my-2">
                          <h5 className="card-title mb-0">{offer?.title}</h5>
                        </div>
                      </div>
                    </div>
                    <div className="back_details">
                      <div className="text-center">
                        <div className="card-body p-0">
                          <p className="card-text offer-text py-2 w-100 mb-0">
                            {offer?.text}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
export default Offers;
